import React from 'react';
import { Player } from '@lottiefiles/react-lottie-player';
import { cn } from '@/utils/styles';

interface LongevityDetailsCardProps {
  mainText: string;
  isMainTextPercentage?: boolean;
  subText: string;
  subTextColor?: string;
  title?: string;
  overlayImg?: string;
  footer?: string;
  additionalText?: string;
  videoSrc?: any;
  size: 'lg' | 'sm' | 'md';
  className?: string;
  'data-testid'?: string;
}

export const LongevityDetailsCard: React.FC<LongevityDetailsCardProps> = ({
  mainText,
  subText,
  subTextColor,
  isMainTextPercentage,
  additionalText,
  overlayImg,
  videoSrc,
  'data-testid': testId,
}) => {
  return (
    <div 
      data-testid={testId}
      className="h-full w-full cursor-auto select-none"
    >
      {videoSrc && (
        <div 
          data-testid={`${testId}-videoContainer`}
          className="h-[24rem] xl:h-[32rem] relative"
        >
          <div 
            data-testid={`${testId}-videoOverflow`}
            className="absolute inset-0 overflow-hidden"
          >
            <Player
              data-testid={`${testId}-videoPlayer`}
              autoplay
              loop
              src={videoSrc}
              className="rounded-lg object-cover"
              style={{
                position: 'absolute',
                top: 0,
                left: 0,
                height: '100%',
                width: '100%',
              }}
            />
          </div>
          {overlayImg && (
            <div 
              data-testid={`${testId}-overlayContainer`}
              className="absolute inset-0 mt-8 lg:mt-4 max-sm:mt-0 flex flex-col justify-center items-center"
            >
              <img
                data-testid={`${testId}-overlayImage`}
                src={overlayImg}
                alt={mainText || 'overlay'}
                className="w-full max-h-[14rem] xl:max-h-[16rem] max-sm:h-[12rem] object-contain pointer-events-none"
                loading='lazy'
              />
            </div>
          )}
          <div
            data-testid={`${testId}-textContent`}
            className={cn(
              'absolute inset-0 flex flex-col justify-center items-center',
              additionalText
                ? 'mt-12 lg:mt-8 max-sm:mt-4'
                : 'mt-10 lg:mt-8 max-sm:mt-6',
            )}
          >
            <p
              data-testid={`${testId}-mainText`}
              className={cn(
                'dark text-primary font-serif',
                isMainTextPercentage ? 'max-sm:typography-h5 typography-num-large' : 'max-md:typography-h5 typography-d1',
              )}
            >
              {mainText}
            </p>
            <p
              data-testid={`${testId}-subText`}
              className={cn(
                'dark typography-body text-primary',
                additionalText ? 'mt-2' : 'mt-4',
              )}
              style={{ color: subTextColor }}
            >
              {subText}
            </p>
            <p 
              data-testid={`${testId}-additionalText`}
              className="dark typography-caption1 mt-1 text-[#A0A1AD]"
            >
              {additionalText}
            </p>
          </div>
        </div>
      )}
    </div>
  );
};
